module.exports = __webpack_public_path__ + "static/media/github.5669607e.svg";